import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { skeletonCSS } from '../../common/styles';
var gridSize = gridSizeFn();
export var buttonHeight = gridSize * 4;
export var margin = {
  left: gridSize / 2
};
export var padding = {
  all: gridSize / 2
};
export var getPrimaryButtonTheme = function getPrimaryButtonTheme(_ref) {
  var primaryButton = _ref.mode.primaryButton;
  return function (current, props) {
    var _current = current(props),
        buttonStyles = _current.buttonStyles,
        spinnerStyles = _current.spinnerStyles;

    return {
      buttonStyles: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, buttonStyles), primaryButton.default), props.isSelected && primaryButton.active), {}, {
        fontWeight: 500,
        padding: '0 4px',
        marginLeft: 0,
        marginRight: 0,
        ':hover': primaryButton.hover,
        ':focus': primaryButton.focus,
        // :active doesn't work in FF, becasue we do a
        // e.preventDefault() on mouse down in Button.
        // '&&' is required to add more CSS specificity
        // && it not a valid CSSObject property
        // @ts-ignore
        '&&': _objectSpread({}, props.state === 'active' && primaryButton.active)
      }),
      spinnerStyles: spinnerStyles
    };
  };
};
export var primaryButtonSkeletonCSS = function primaryButtonSkeletonCSS(theme) {
  return _objectSpread({
    borderRadius: "".concat(gridSize / 2, "px"),
    display: 'inline-flex',
    height: "".concat(buttonHeight - padding.all * 2.5, "px"),
    width: '68px'
  }, skeletonCSS(theme));
};
export var isHighlightedCSS = function isHighlightedCSS(_ref2, isHighlighted) {
  var primaryButton = _ref2.mode.primaryButton;
  return _objectSpread({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    position: 'relative'
  }, isHighlighted && {
    '&& > *': {
      color: primaryButton.selected.color
    },
    '&:after': {
      position: 'absolute',
      bottom: 0,
      left: gridSize / 2,
      right: gridSize / 2,
      content: '""',
      height: 3,
      backgroundColor: primaryButton.selected.borderColor,
      borderTopLeftRadius: 1,
      borderTopRightRadius: 1
    }
  });
};